import { get } from "../index";

export const getExportHistory = (projectId) =>
  get(`/timelines/export-history/${projectId}`);
